<template>
  <div class="video-monitor">
    <div id="video-container" style="width:143px;height:285px"></div>
  </div>
</template>
<script>
import EZUIKit from "ezuikit-js"
var player = null
export default {
  props: {
    stationId: { type: String },
    url: { type: String },
    appKey: { type: String },
    appSecret: { type: String }
  },
  data() {
    return {
      screenWidth: 0
    }
  },
  watch: {
    url() {
      player && player.stop()
      this.init()
    },
  },
  mounted() {
    window.screenWidth = document.body.clientWidth
    window.screenHeight = document.body.clientHeight
    this.screenWidth = window.screenWidth - 20
    this.init()
  },
  destroyed() {
    this.destroy()
  },
  methods: {
    init() {
      // const appKey = 'a0eeb9fd96304730b2ed0c5736c20a62'
      // const appSecret = 'd3606df7776ffae293da83806236ccc9'
      const appKey = this.appKey
      const appSecret = this.appSecret
      console.log(appKey)
      console.log(appSecret)
      fetch('https://open.ys7.com/api/lapp/token/get', {
        method: 'post',
        body: `appKey=${appKey}&appSecret=${appSecret}`,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      ).then(response => response.json())
        .then(res => {
          console.log(this.url)
          const accessToken = res.data.accessToken;
          console.log(accessToken)
          // player = new EZUIPlayer({
          player = new EZUIKit.EZUIKitPlayer({
            id: 'video-container', // 视频容器ID
            accessToken: accessToken,
            url: this.url,
            // simple - 极简版; pcLive-pc直播；pcRec-pc回放；mobileLive-移动端直播；mobileRec-移动端回放;security - 安防版;voice-语音版;
            template: 'mobileLive',
            disabledPTZ: true,
            plugin: ['talk'], // 加载插件，talk-对讲
            width: this.screenWidth,
            height: 250,
            autoplay: [false],
          });

        });
    },
    destroy() {
      var destroyPromise = player.destroy();
      destroyPromise.then((data) => {
        console.log("promise 获取 数据", data)
      })
    }
  }
}
</script>
<style>
.video-monitor {
  display: flex;
  justify-content: center;
}
</style>
